<template>
  <div class="page-inner login-form">
    <v-form ref="form">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>아이디(휴대폰 번호)</v-list-item-title>
          <v-text-field
            class="custom-shadow-input phone-input"
            solo
            height="52"
            placeholder="- 없이 숫자만 입력해 주세요"
            required
            type="number"
            v-model="loginId"
            :rules="[loginIdRules.required, cellRules.min, cellRules.max]"
          >
            <template v-slot:prepend-inner>
              <span class="country-code">+82</span>
            </template>
          </v-text-field>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>비밀번호</v-list-item-title>
          <v-text-field
            class="custom-shadow-input"
            solo
            height="52"
            label="비밀번호를 입력해 주세요"
            required
            v-model="password"
            :append-icon="pwShow ? 'mdi-eye' : 'mdi-eye-off'"
            :type="pwShow ? 'text' : 'password'"
            @click:append="pwShow = !pwShow"
            :rules="[loginPasswordRules.required, loginPasswordRules.counter]"
          />
        </v-list-item-content>
      </v-list-item>

      <v-btn
        class="mt-6 mb-4 btn-text-white"
        color="mainColorDark"
        x-large
        depressed
        block
        @click="onClickSignIn"
        >로그인</v-btn
      >
    </v-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
const rulesService = require("@/utils/rules.js");
import Cookies from "js-cookie";

export default {
  components: {},
  data() {
    return {
      step: "login",
      userData: null,
      currentMode: "",
      kakaoAccount: null,
      // isDev: process.env.NODE_ENV === "development",
      pwShow: false,
      loginId: "",
      password: "",
      loginIdRules: rulesService.loginIdRules(),
      cellRules: rulesService.cellRules(),
      loginPasswordRules: rulesService.loginPasswordRules(),
    };
  },
  computed:{
    ...mapGetters(["isDev"]),
  },
  mounted() {
    // 개발모드에서 처리
    if (this.isDev) {
      // this.loginId = "01081021875";
      // this.password = "18751875!";
      // this.loginId = "01067713230";
      // this.password = "123456789!";
      this.loginId = "01011112222";
      this.password = "123456789!";
    }
    if (
      Cookies.get("zplabSaveLoginId") !== null &&
      Cookies.get("zplabSaveLoginId") !== undefined &&
      Cookies.get("zplabSaveLoginId") !== ""
    ) {
      this.loginId = Cookies.get("zplabSaveLoginId");
    }
  },
  methods: {
    onClickSignIn() {
      if (!this.$refs.form.validate()) return;
      this.$emit("onClickSignIn", this);
    },
    // moveTo(to) {
    //   this.$emit("moveToEmit", to);
    // },
    ...mapActions(["saveDataPreLoginQuery"]),
  },
};
</script>

<style lang="scss">
.page-inner.login-form {
  padding-bottom: 0;

  .v-label {
    color: gray !important;
  }

  .v-list-item {
    padding: 0;

    .v-list-item__content {
      padding: 0;
    }

    .v-list-item__title {
      font-size: 14px;
      font-weight: bold;
      padding: 0 15px 0;
      color: $primary-text-color;

      .asterisk {
        color: $text-red;
      }
    }
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox  */
  input[type="number"] {
    -moz-appearance: textfield;
  }

  .custom-shadow-input.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) {
    > .v-input__control > .v-input__slot {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08)!important; // 그림자 적용
      border: none; // 기존 border 없애거나 변경
      padding: 0 22px !important;
    }
  }
}
</style>
